module.exports = __webpack_public_path__ + "static/img/fm.7b3e1d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fm.jpg
// module id = xl3p
// module chunks = 1